import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Heatmap from 'highcharts/modules/heatmap';
import Exporting from 'highcharts/modules/exporting';
import highchartsTheme from './theme/highchartsTheme';
import App from './App';
import './index.css';

// Initialize Highcharts modules once before anything renders
const init = (mod) => { const fn = mod.default || mod; if (typeof fn === 'function') fn(Highcharts); };
init(HighchartsMore);
init(SolidGauge);
init(Heatmap);
init(Exporting);

// Apply dark theme globally
Highcharts.setOptions(highchartsTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
